import MaskedPhoneNumber from './MaskedPhoneNumber.component';

export default MaskedPhoneNumber;
